import React from 'react';
import { useNavigate } from 'react-router-dom';

function BottomNavigation() {
  const navigate = useNavigate();
  
  return (
    <>
      <div className="bottom-navigation">
        <button 
          className="nav-button"
          onClick={() => navigate('/learner')}
        >
          <span className="nav-icon">📝</span>
          <span className="nav-label">Current</span>
        </button>
        
        <button 
          className="nav-button"
          onClick={() => navigate('/learner', { state: { activeTab: 'upcoming' } })}
        >
          <span className="nav-icon">📅</span>
          <span className="nav-label">Upcoming</span>
        </button>
        
        <button 
          className="nav-button"
          onClick={() => navigate('/learner', { state: { activeTab: 'portfolio' } })}
        >
          <span className="nav-icon">📚</span>
          <span className="nav-label">Portfolio</span>
        </button>
      </div>
      
      {/* Extra space at bottom to prevent content from being hidden */}
      <div className="bottom-space"></div>
    </>
  );
}

export default BottomNavigation;